(($) => {
  $(document).ready(() => {

    // wpcf7-mail-sent-ng
    // wpcf7-mail-sent-ok

    $('form').submit(function() {
      const interval = window.setInterval(() => {
        if ($(this).find('.wpcf7-mail-sent-ng').size()) {
          $(this).find('.wpcf7-mail-sent-ng').removeClass('wpcf7-mail-sent-ng').addClass('wpcf7-mail-sent-ok').text('Mensagem enviada com sucesso')
          window.clearInterval(interval)
        }
      }, 1000)

    });

  })
})(jQuery)
